import cookies from 'js-cookie';
import { select } from '../shared/utils/dom';
import { delimiters } from '../shared/constants';
import loadingMixin from '../shared/vue/mixins/loading';
import { addPaymentMethod, removeErrors, getErrorMessages, achPaymentApi, showError, showSuccessErrorMessage } from './api';
import dataLayerPush from '../shared/utils/analytics';
import { createError, removeError } from '../shared/formErrors';
import formMixin from '../shared/vue/mixins/form';

const achThresholdCookieName = 'achValidationThresholdHasBeenExceeded';

export default function addBankAccount() {
  const el = select('[data-vue-app="add-bank-account"]');
  if (!el) {
    return;
  }

  new Vue({
    el,
    delimiters,
    mixins: [loadingMixin, formMixin],
    data: {
      tableData: window.VueTables ? window.VueTables.bankAccounts : [],
      accountNumber: '',
      accountType: 'Checking',
      routingNumber: '',
      reenterAccountNumber: '',
      liveText: '',
      updateOneTimePayment: false,
      duplicateBankAccount: false,
      validationMessage: '',
      valid: false,
      achCounter: 0,
      achThresholdExceeded: false,
      agreeACH: false,
      errorMessages: getErrorMessages(),
    },
    created() {
      Event.$on('updateOneTimePayment', (response) => {
        this.updateOneTimePayment = response.updateOneTimePayment;
        this.loading = true;
        this.postFormContents();
      });
    },
    mounted() {
      this.achThresholdExceeded = cookies.get(achThresholdCookieName) ? cookies.get(achThresholdCookieName) : false;
    },
    methods: {
      postFormContents() {
        let hasError = false;
        if (!this.routingNumber) {
          createError(this.$refs.routingNumber, this.$refs.routingNumberError, 'Please enter a routing number.');
          hasError = true;
        } else {
          removeError(this.$refs.routingNumber, this.$refs.routingNumberError);
        }
        if (!this.accountNumber) {
          createError(this.$refs.accountNumber, this.$refs.accountNumberError, 'Please enter an account number.');
          hasError = true;
        } else {
          removeError(this.$refs.accountNumber, this.$refs.accountNumberError);
        }
        if (!this.reenterAccountNumber) {
          createError(this.$refs.reenterAccountNumber, this.$refs.reenterAccountNumberError, 'Please reenter the account number.');
          hasError = true;
        } else if (this.accountNumber !== this.reenterAccountNumber) {
          createError(this.$refs.reenterAccountNumber, this.$refs.reenterAccountNumberError, 'Account numbers do not match.');
          hasError = true;
        } else {
          removeError(this.$refs.reenterAccountNumber, this.$refs.reenterAccountNumberError);
        }
        if (hasError) {
          // update live text to let the user know there are errors
          this.liveText = 'The form has errors. Please make sure your payment information is correct.';
          this.loading = false;
        } else {
          this.loading = true;
          this.duplicateBankAccount = false;
          achPaymentApi.validateAccountNumber(this, false, true)
            .then((response) => {
              this.loading = false;
              this.submitting = false;
              this.validationMessage = response.data.validationMessage;
              this.valid = response.data.valid;
              if (!response.data.uSBankDown) {
                if (this.valid) {
                  this.proceedAddBankAccount();
                } else {
                  const message = { PrimaryMessage: "We're Sorry", SecondaryMessage: this.validationMessage };
                  showError("ach-payment-error", message);
                  this.achCounter += 1;
                  if (this.achCounter >= 3) {
                    console.log(this.achCounter);
                    this.sendAchRemark();
                    this.achThresholdExceeded = true;
                    cookies.set(achThresholdCookieName, true);
                    Event.$emit('A11yDialogOpen', { dialogKey: 'ach-validation-threshold-exceeded' });
                  }
                }
              } else {
                this.proceedAddBankAccount();
              }
            })
            .catch(err => {
              this.loading = false;
              console.log(err);
            });
        }
      },
      postAddBankAccount() {
        this.loading = false;
        this.success = true;
        dataLayerPush('AddBankAccount');
        Event.$emit('A11yDialogOpen', { dialogKey: 'add-bank-account-success' });
      },
      sendAchRemark() {
        this.loading = true;
        this.submitting = true;
        achPaymentApi.sendAchRemark(this, false, true)
          .then(() => {
            this.loading = false;
            this.submitting = false;
          })
          .catch(() => {
            this.loading = false;
            this.submitting = false;
            removeErrors();
            showSuccessErrorMessage(this.errorMessages, "OTP-06");
          })
      },
      proceedAddBankAccount() {
        if (window.ldcCode === 'NI') {
          addPaymentMethod.addCISBankAccount(this)
            .then(() => {
              this.postAddBankAccount();
            })
            .catch(err => {
              this.loading = false;
              console.log(err);
            });
        } else {
          addPaymentMethod.addDISBankAccount(this)
            .then(() => {
              this.postAddBankAccount();
            })
            .catch(err => {
              this.loading = false;
              console.log(err);
              if (err && err.SecondaryMessage && err.SecondaryMessage.includes("Failed with code 2017")) {
                this.duplicateBankAccount = true;
                removeErrors();
              }
            });
        }
      },
    },
  });
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/addBankAccount.js